import React, { useEffect } from 'react';
import { useNavigate, useParams } from 'react-router-dom';

const VideoPlayer = () => {
    const navigate = useNavigate();
    const { movieName, playerId } = useParams();
    const [source, setSource] = React.useState(1);

    const sources = [
        'https://play2.123embed.net/movie/',

    ];



    return (
        <>
            <div className='video-player-wrapper'>
                <div className='video-player'>
                    <div className='player-header vivify fadeIn duration-400 delay-800'>
                        <img src='/assets/eatpopcorn.svg' alt='logo' />

                        <div className='player-header-controls'>
                            {/* Decode the movie name since we encoded it when navigating */}
                            <h1>{decodeURIComponent(movieName)}</h1>
                            <button onClick={() => navigate('/')}>
                                <i className='material-icons'>close</i>
                            </button>
                        </div>
                    </div>
                    <div className='player-video'>
                        <iframe
                            className='vivify fadeIn duration-500 delay-200'
                            src={`https://play2.123embed.net/movie/${playerId}`}
                            width="1200px"
                            height="500px"
                            frameBorder="0"
                            allowFullScreen
                        ></iframe>
                    </div>
                    <div className='source-control vivify fadeIn duration-400 delay-800'>
                        <h3>Having Trouble Streaming? Try Another Source</h3>
                        <div className='vert-line'></div>
                        <div className='source-control-buttons'>
                            <button onClick={
                                () => {
                                    setSource(1);
                                }
                            } className='active-source'>Source 1</button>
                            <button onClick={
                                () => {
                                    setSource(2);
                                }
                            }>Source 2</button>
                            <button onClick={
                                () => {
                                    setSource(3);
                                }
                            }>Source 3</button>
                        </div>
                    </div>
                </div>
            </div>
        </>
    );
};

export default VideoPlayer;
